(() => {
  // Respect deep links
  const url = new URL(window.location.href);
  if (url.searchParams.has('variant')) return;

  // Section + hints from Liquid
  const section = document.querySelector('[id^="CoffeeProduct-"][data-section]');
  if (!section) return;
  const hintVariantId = section.getAttribute('data-default-variant-id') || '';
  const hintWeight = (section.getAttribute('data-default-weight') || '').trim();

  function whenReady(cb){
    if (document.readyState === 'complete' || document.readyState === 'interactive') queueMicrotask(cb);
    else document.addEventListener('DOMContentLoaded', cb, { once:true });
  }

  whenReady(() => {
    const radios  = section.querySelector(`variant-radios[data-section="${section.dataset.section}"]`);
    const selects = section.querySelector(`variant-selects[data-section="${section.dataset.section}"]`);
    const picker  = radios || selects;
    if (!picker) return;

    const json = picker.querySelector('script[type="application/json"]');
    if (!json) return;

    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch { return; }

    const norm = s => (s || '').toString().toLowerCase().replace(/\s+/g,'').trim();
    const isAvail = v => v && v.available !== false;

    function choosePreferred(){
      if (hintVariantId) {
        const v = variants.find(v => String(v.id) === String(hintVariantId) && isAvail(v));
        if (v) return v;
      }
      if (hintWeight) {
        const w = norm(hintWeight);
        const v = variants.find(v => isAvail(v) && [v.option1,v.option2,v.option3].filter(Boolean).some(o => norm(o) === w));
        if (v) return v;
      }
      const targets = new Set(['500g','500 g','0.5kg','0.5 kg']);
      return variants.find(v => isAvail(v) && [v.option1,v.option2,v.option3].filter(Boolean).some(o => targets.has(o.toLowerCase()))) || null;
    }

    const preferred = choosePreferred();
    if (!preferred) return;

    function applyToRadios(v){
      const sets = Array.from(picker.querySelectorAll('fieldset.product-form__input'));
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      sets.forEach((fs, i) => {
        const legend = fs.querySelector('legend'); if (!legend) return;
        const name = legend.textContent.trim();
        const val = opts[i]; if (!val) return;
        const input = fs.querySelector(`input[name="${CSS.escape(name)}"][value="${CSS.escape(val)}"]`);
        if (input && !input.checked) input.checked = true;
      });
      const last = sets[sets.length - 1]?.querySelector('input:checked');
      if (last) last.dispatchEvent(new Event('change', { bubbles:true }));
    }

    function applyToSelects(v){
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      opts.forEach((val, i) => {
        const sel = picker.querySelector(`#Option-${section.dataset.section}-${i}`);
        if (sel && sel.value !== val) sel.value = val;
      });
      const lastSel = picker.querySelector(`#Option-${section.dataset.section}-${opts.length - 1}`);
      if (lastSel) lastSel.dispatchEvent(new Event('change', { bubbles:true }));
    }

    if (radios) applyToRadios(preferred); else if (selects) applyToSelects(preferred);

    // Safety net: ensure hidden input + button are actually enabled
    const form   = section.querySelector('form[action*="/cart/add"]');
    const idIn   = form && form.querySelector('input[name="id"]');
    const submit = section.querySelector('button.product-form__submit');

    setTimeout(() => {
      if (idIn) {
        if (String(idIn.value) !== String(preferred.id)) idIn.value = preferred.id;
        if (idIn.hasAttribute('disabled')) idIn.removeAttribute('disabled');
      }
      if (submit && submit.hasAttribute('disabled') && isAvail(preferred)) {
        submit.removeAttribute('disabled');
        submit.ariaDisabled = 'false';
      }
      // Keep URL tidy
      url.searchParams.set('variant', preferred.id);
      window.history.replaceState({}, '', url);
    }, 50);
  });
})();